import { Link } from "@tanstack/react-router";
import { Trans } from "@lingui/react/macro";
import { clearBuilderFlowState } from "../lib/builderFlowStorage";

export default function SiteFooter() {
  return (
    <footer
      className="relative overflow-hidden bg-[#1a1a1a] text-white"
      data-testid="landing-footer"
    >
      <div className="relative mx-auto max-w-6xl px-4 pb-6 pt-16 sm:px-6 sm:pb-8 sm:pt-20">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1.4fr)_minmax(0,0.85fr)_minmax(0,0.95fr)]">
          <div className="max-w-xl">
            <h2 className="font-display text-5xl italic leading-[0.92] tracking-[-0.03em] text-white sm:text-6xl">
              <Trans>
                Haz que tu fecha se sienta especial desde el primer clic.
              </Trans>
            </h2>
            <Link
              className="app-btn-primary mt-8 w-fit bg-white !text-[#1a1a1a] hover:!bg-gray-100"
              data-testid="landing-footer-start"
              onClick={clearBuilderFlowState}
              search={{ step: undefined, template: undefined }}
              to="/create"
            >
              <Trans>Empezar Gratis</Trans>
            </Link>
          </div>

          <div className="space-y-5">
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-white/50">
              <Trans>Soporte</Trans>
            </p>
            <nav aria-label="Footer support navigation">
              <ul className="space-y-3 text-sm text-white/70 sm:text-[0.95rem]">
                <li>
                  <Link
                    className="cursor-pointer transition-colors hover:text-white"
                    data-testid="landing-footer-signin"
                    search={{
                      entry: undefined,
                      flow: undefined,
                      template: undefined,
                    }}
                    to="/auth/signin"
                  >
                    <Trans>Iniciar Sesión</Trans>
                  </Link>
                </li>
                <li>
                  <Link
                    className="cursor-pointer transition-colors hover:text-white"
                    data-testid="landing-footer-prices"
                    to="/prices"
                  >
                    <Trans>Precios</Trans>
                  </Link>
                </li>
                <li>
                  <Link
                    className="cursor-pointer transition-colors hover:text-white"
                    data-testid="landing-footer-blog"
                    to="/blog"
                  >
                    <Trans>Blog</Trans>
                  </Link>
                </li>
                <li>
                  <Link
                    className="cursor-pointer transition-colors hover:text-white"
                    data-testid="landing-footer-help"
                    to="/help"
                  >
                    <Trans>Ayuda</Trans>
                  </Link>
                </li>
                <li>
                  <a
                    className="cursor-pointer text-white/70 transition-colors hover:text-white"
                    data-testid="landing-footer-support"
                    href="mailto:soporte@bodaweb.site"
                  >
                    soporte@bodaweb.site
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          <div className="space-y-5">
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-white/50">
              <Trans>Legal</Trans>
            </p>
            <nav aria-label="Footer legal navigation">
              <ul className="space-y-3 text-sm text-white/70 sm:text-[0.95rem]">
                <li>
                  <Link
                    className="cursor-pointer transition-colors hover:text-white"
                    data-testid="landing-footer-privacy"
                    to="/privacy"
                  >
                    <Trans>Privacidad</Trans>
                  </Link>
                </li>
                <li>
                  <Link
                    className="cursor-pointer transition-colors hover:text-white"
                    data-testid="landing-footer-terms"
                    to="/terms"
                  >
                    <Trans>Términos</Trans>
                  </Link>
                </li>
              </ul>
            </nav>
            <p className="max-w-xs text-sm leading-6 text-white/50">
              <Trans>
                ¿Buscas un diseño a medida para tu boda? Escríbenos y te
                ayudamos a darle una dirección más personalizada.
              </Trans>
            </p>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-5 text-xs uppercase tracking-[0.24em] text-white/40 sm:flex-row sm:items-center sm:justify-between">
          <p>
            <Trans>© 2026 BodaWeb</Trans>
          </p>
          <p>
            <Trans>
              Invitaciones digitales pensadas para sentirse personales.
            </Trans>
          </p>
        </div>
      </div>
    </footer>
  );
}
